export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./quick-login-reg.vue?vue&type=template&id=b281505c"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/quick-login-reg/quick-login-reg.vue?vue&type=template&id=b281505c
// module id = +pgQ
// module chunks = 0